////////////////////////////////
// Menu
////////////////////////////////
document.addEventListener("click", function(e) {
    var clickTarget = e.target.closest("li.has--children button");

    if (!clickTarget) return;

    var navItem = clickTarget.closest("li.has--children");
    if (!navItem) return;

    e.preventDefault();
    var navSubmenu = navItem.querySelector("ul");

    if (navSubmenu) {
        navSubmenu.classList.toggle("open");
        clickTarget.setAttribute("aria-expanded", navSubmenu.classList.contains("open"));
    }
});

// Beim Scrollen alle offenen Untermenüs schließen
document.addEventListener("scroll", function() {
    document.querySelectorAll("li.has--children ul.open").forEach(function(submenu) {
        submenu.classList.remove("open");
        var button = submenu.closest("li.has--children").querySelector("button");
        if (button) {
            button.setAttribute("aria-expanded", "false");
        }
    });
});

// Tastatursteuerung: Enter oder Leertaste öffnet/schließt Untermenüs, Escape schließt alle Untermenüs
// document.addEventListener("keypress", function(e) {
//     if (e.key !== "Enter" && e.key !== " ") return;

//     var button = e.target.closest("li.has--children button");
//     if (!button) return;

//     var navItem = button.closest("li.has--children");
//     if (!navItem) return;

//     e.preventDefault();
//     var navSubmenu = navItem.querySelector("ul");

//     if (navSubmenu) {
//         navSubmenu.classList.toggle("open");
//         button.setAttribute("aria-expanded", navSubmenu.classList.contains("open"));
//     }
// });

// Escape-Taste schließt alle offenen Untermenüs
document.addEventListener("keydown", function(e) {
    if (e.key !== "Escape") return;

    document.querySelectorAll("li.has--children ul.open").forEach(function(submenu) {
        submenu.classList.remove("open");
        var button = submenu.closest("li.has--children").querySelector("button");
        if (button) {
            button.setAttribute("aria-expanded", "false");
        }
    });
});


// Escape-Taste schließt alle offenen Untermenüs
document.addEventListener('DOMContentLoaded', () => {
    const menuBtn = document.querySelector('#burger-menu');

    menuBtn.addEventListener('click', () => {
        const hasOpen = document.documentElement.classList.contains('ionav--open');
        const isOpen = !hasOpen;
        menuBtn.setAttribute('aria-expanded', isOpen);
    });

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            document.documentElement.classList.remove('ionav--open');
            menuBtn.setAttribute('aria-expanded', false);
        }
    });
});
